import { render, staticRenderFns } from "./AddReturnExpand.vue?vue&type=template&id=c8567b48&"
import script from "./AddReturnExpand.vue?vue&type=script&lang=js&"
export * from "./AddReturnExpand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports